var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientandorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "title",
    width: 19.876,
    height: 18.22,
    viewBox: "0 0 19.876 18.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_816",
    transform: "translate(2.485 6.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    d: "M10.661 11.485a.621.621 0 0 1-.621-.621v-.621h-5.8v.621a.621.621 0 0 1-1.242 0V9.621A.621.621 0 0 1 3.621 9h7.04a.621.621 0 0 1 .621.621v1.242a.621.621 0 0 1-.621.622z",
    transform: "translate(-3 -9)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_817",
    transform: "translate(6.004 6.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    d: "M7.871 17.118a.621.621 0 0 1-.621-.618V9.871a.621.621 0 1 1 1.242 0V16.5a.621.621 0 0 1-.621.618z",
    transform: "translate(-7.25 -9.25)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_818",
    transform: "translate(4.969 13.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    d: "M8.692 18.742H6.621a.621.621 0 1 1 0-1.242h2.07a.621.621 0 1 1 0 1.242z",
    transform: "translate(-6 -17.5)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_819",
    transform: "translate(12.423 6.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    d: "M19.348 10.242h-3.727a.621.621 0 0 1 0-1.242h3.727a.621.621 0 0 1 0 1.242z",
    transform: "translate(-15 -9)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_820",
    transform: "translate(12.423 9.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    d: "M19.348 14.242h-3.727a.621.621 0 0 1 0-1.242h3.727a.621.621 0 0 1 0 1.242z",
    transform: "translate(-15 -13)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_821",
    transform: "translate(12.423 13.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    d: "M19.348 18.242h-3.727a.621.621 0 0 1 0-1.242h3.727a.621.621 0 0 1 0 1.242z",
    transform: "translate(-15 -17)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    d: "M17.6 19.22H2.278A2.279 2.279 0 0 1 0 16.943V3.278A2.279 2.279 0 0 1 2.278 1H17.6a2.279 2.279 0 0 1 2.278 2.278v13.665A2.279 2.279 0 0 1 17.6 19.22zM2.278 2.242a1.037 1.037 0 0 0-1.036 1.036v13.665a1.037 1.037 0 0 0 1.035 1.035H17.6a1.037 1.037 0 0 0 1.035-1.035V3.278A1.037 1.037 0 0 0 17.6 2.242z",
    transform: "translate(0 -1)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_823",
    transform: "translate(0 2.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    d: "M19.255 5.742H.621a.621.621 0 1 1 0-1.242h18.634a.621.621 0 1 1 0 1.242z",
    transform: "translate(0 -4.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientandorder);
export default __webpack_public_path__ + "static/media/clientandorder.bd1e08859af9f5b885265af4d0c16a70.svg";
export { ForwardRef as ReactComponent };